import { useRouter } from 'next/router';
import React from 'react';
import { ratingsListUrl } from 'src/helpers/ratings';
import { getRating, getReviewType } from 'src/helpers/reviews';
import { IReviewFilters } from 'src/interfaces/reviews';
import { useProductsTags } from 'src/store/hooks/filters';
import { useOrganizationDetails } from 'src/store/hooks/organizations';
import { useProductsRating, useServicesRating } from 'src/store/hooks/ratings';
import { useReviewsStats } from 'src/store/hooks/reviews';
import { TReviewListQuery } from 'src/types/router';

import { Space } from '@sravni/react-design-system';

import styles from '../../reviews-list-header.module.scss';

import {
  HeadingBlock,
  RatesBlock,
  RatingBlocks,
  WrapperAdvertisingButton,
  WinnerLabel,
  OrganizationMenu,
} from './components';

interface IOrganizationHeaderProps {
  headingPage: string;
  currentServerFilters: IReviewFilters;
  showMenu?: boolean;
  isMobile: boolean;
}

export const OrganizationHeader: React.FC<IOrganizationHeaderProps> = ({
  headingPage,
  currentServerFilters,
  showMenu,
  isMobile,
}) => {
  const router = useRouter() as TRouter<TReviewListQuery>;
  const {
    query: { organization, type, product, specificProduct },
  } = router;
  const productsTags = useProductsTags();
  const reviewTypes = getReviewType(type, productsTags);
  const servicesRating = useServicesRating();
  const typePage = reviewTypes.itemTypeUrl;
  const reviewsStats = useReviewsStats();
  const { position, id, alias } = useOrganizationDetails(organization);
  const organizationAdvertisingButton = useOrganizationDetails(alias);
  const productRating = useProductsRating(specificProduct);
  const getUrlRating = ratingsListUrl(type, reviewTypes);
  const productTag = currentServerFilters.tag.find(({ alias }) => alias === product)?.key;
  const rating = getRating(position, productRating, servicesRating, specificProduct, productTag);
  const { squareLogo, roundLogo, isRecomended, partnerCard, ad } = useOrganizationDetails(organization);
  const isEmptyReviewsStats = !!Object.keys(reviewsStats).length;

  return (
    <Space className={styles.wrapper} direction={'vertical'} size={24}>
      <Space direction="vertical">
        <HeadingBlock
          heading={headingPage}
          logoSrc={squareLogo || roundLogo}
          isPartner={isRecomended || partnerCard}
          rating={rating}
          urlRating={getUrlRating}
        />
        <WinnerLabel id={id} type={typePage} isMobile={isMobile} />
        {showMenu && <OrganizationMenu organizationAlias={alias} currentAlias="otzyvy" isMobile={isMobile} />}
        <WrapperAdvertisingButton type={type} organization={organizationAdvertisingButton} ad={ad} />
        <Space size={32} className={isEmptyReviewsStats && 'h-mt-32'} direction={isMobile ? 'vertical' : 'horizontal'}>
          {reviewsStats && <RatingBlocks reviewsStats={reviewsStats} />}
          <RatesBlock />
        </Space>
      </Space>
    </Space>
  );
};
